"use client";

import { useBranding } from "@/providers/branding-provider";
import { usePathname } from "next/navigation";

export function useActiveRoute() {
  const branding = useBranding();
  const slug = branding.slug;
  const pathname = usePathname();

  const getActiveRoute = (targetPath: string) => {
    if (!slug) return pathname === targetPath;

    const slugPrefix = `/${slug}`;
    const pathWithoutSlug = pathname.startsWith(slugPrefix)
      ? pathname.slice(slugPrefix.length) || "/"
      : pathname;

    return pathWithoutSlug === targetPath;
  };

  const isActive = (targetPath: string) => getActiveRoute(targetPath);

  return {
    isActive,
    pathnameWithoutSlug: slug
      ? pathname.replace(`/${slug}`, "") || "/"
      : pathname,
  };
}
